<template>
    <el-dialog title="到场地-港口信息维护" :visible="visible" :show="show" width="50%"  @close="close"     :close-on-click-modal="false" custom-class="module-dialog">
        <span style="text-align:center;color:red">如有相同的到场地-港口信息配置自动覆盖之前的数据</span>
        <el-form class="detail-form-content" ref="ruleForm" :model="ruleForm" :rules="rules" label-width="120px">
            <el-form-item label="到场地信息" class="input" prop="siteName" >
                <el-select v-model="ruleForm.siteName" placeholder="请选择到场地" style="width:80%">
                    <el-option v-for="item in siteList" :label="item.orgName" :value="item.orgName"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="港口信息" class="input" prop="portId" >
                <el-select v-model="ruleForm.portId" placeholder="请选择港口" style="width:80%" @change="changePort">
                    <el-option v-for="item in portList" :label="item.portName" :value="item.portId"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="铁路运费" class="input" prop="trainPrice" >
                <el-input-number :controls="false" v-model="ruleForm.trainPrice" style="width:80%" placeholder="请输入铁路运费">
                </el-input-number>
            </el-form-item>
            <div style="display: flex;flex-wrap: wrap;width: 100%;justify-content: center;">
                <el-button class="btn" type="primary" v-show="updateBtn" @click="commit()">保存</el-button>
                <el-button class="btn close" @click="close()">取消</el-button>
            </div>
        </el-form>
    </el-dialog>
</template>
<script>
    import base from '../../../utils/base'
    export default{
        name:'addOrUpdate',
        props:{
            show: {
                type: Boolean,
                default: false
            },
            rowData: {
                type: Object,
                default: function(){
                    return {};
                },
            },
        },
        watch:{
            show(){
                this.visible = this.show;
                if(this.show){
                    window.vm = this;
                    this.initPortList();
                    this.getSiteList();
                }
            },
            rowData(){
                this.ruleForm = this.rowData;
                if (this.rowData.type=='info'){
                    this.updateBtn = false;
                }
            },
        },
        data(){
            return{
                updateBtn:true,
                url:base.get().url,
                visible:false,
                ruleForm:{
                    title:'',
                    context:'',
                    isShow:'',
                    img:'',
                    portId:null,
                },
                rules:{
                    siteName:[{ required: true, message: '请选择场地', trigger: 'blur' }],
                    portName:[{ required: true, message: '请选择港口', trigger: 'blur' }],
                    trainPrice:[{ required: true, message: '请输入铁路运费', trigger: 'blur' }],
                },
                portList:[],
                siteList:[],
            }
        },
        methods:{
            close(){
                this.updateBtn = true;
                this.$refs['ruleForm'].resetFields();
                this.$emit("listenToChildEvent",false);
            },
            commit(){
                this.$refs['ruleForm'].validate((valid) => {
                    if (valid) {
                        let loading = this.$loading({
                            lock:true,
                            text:'保存中，请稍候.....',
                            background:'rgba(0,0,0,0.5)'
                        });
                        this.$http({
                            url:  this.ruleForm.id==''|| this.ruleForm.id==undefined?this.url+`baseSitePortConfig/`+"save":
                            this.url+`baseSitePortConfig/`+"update",
                            method: "post",
                            data:this.ruleForm
                        }).then(({ data }) => {
                            loading.close();
                            if (data && data.code === 0) {
                                this.$message({
                                    message: "保存成功",
                                    type: "success",
                                    duration: 1500,
                                    onClose: () => {
                                        this.close();
                                    }
                                });
                            } else {
                                this.$message.error(data.msg);
                            }
                        });
                    }
                });
            },
            initPortList(){
                /*let params = {
                    page: 1,
                    limit: 200,
                    sort: 'id',
                }
                //本表的
                params['dicCode'] = "port_name"//编码名字
                params['dicName'] = "港口名称",//汉字名字*/
                this.$http({
                    url: "port/list",
                    method: "get",
                }).then(({ data }) => {
                    if (data && data.code === 0) {
                        this.portList = data.data;
                    }
                });
            },
            getSiteList(){
                let userId = this.$storage.get("userId");
                this.$http({
                    url: "/sysUserOrg/getZdListByUserId/"+userId,
                    method: "get",
                }).then(({ data }) => {
                    if (data && data.code === 0) {
                        this.siteList = data.zdList;
                    }
                });
            },
            changePort(){
               console.log(this.ruleForm.portId);
                this.portList.forEach(item=>{
                    if(item.portId === this.ruleForm.portId){
                        this.ruleForm.portName = item.portName;
                    }
                })
            }
        }
    }
</script>
<style lang="scss">
    .el-dialog__header {
        background: linear-gradient(135deg, var(--publicMainColor) 0%, #2b5797 100%);
        padding: 16px 20px;
        border-radius: 4px 4px 0 0;
    }

    .el-dialog__title {
        color: #fff;
        font-size: 16px;
        font-weight: 600;
    }

    .el-dialog__headerbtn .el-dialog__close {
        color: rgba(255, 255, 255, 0.8);
        font-size: 16px;
    }

    .el-dialog__headerbtn .el-dialog__close:hover {
        color: #fff;
    }

    .detail-form-content .el-form-item {
        margin-bottom: 20px;
    }

    .detail-form-content .el-form-item__label {
        font-weight: 600;
        color: #303133;
        font-size: 14px;
    }

    .detail-form-content .el-form-item__content {
        line-height: normal;
    }

    .detail-form-content .el-input__inner {
        border-radius: 4px;
        border-color: #dcdfe6;
        transition: border-color 0.25s;
    }

    .detail-form-content .el-input__inner:focus {
        border-color: var(--publicMainColor);
    }

    .detail-form-content .el-select {
        width: 100%;
    }

    .detail-form-content .el-upload-list--picture-card .el-upload-list__item,
    .detail-form-content .el-upload--picture-card {
        width: 120px;
        height: 120px;
        line-height: 126px;
        border-radius: 6px;
        border: 1px dashed #c0ccda;
        transition: border-color 0.25s;
    }

    .detail-form-content .el-upload--picture-card:hover {
        border-color: var(--publicMainColor);
    }

    .detail-form-content .el-upload--picture-card i {
        font-size: 28px;
        color: #8c939d;
    }

    .detail-form-content .el-upload--picture-card:hover i {
        color: var(--publicMainColor);
    }

    .detail-form-content .el-input.is-disabled .el-input__inner {
        background-color: #f5f7fa;
        color: #909399;
        cursor: not-allowed;
    }

    .detail-form-content .form-footer {
        display: flex;
        justify-content: center;
        gap: 12px;
        padding-top: 16px;
        border-top: 1px solid #f0f0f0;
        margin-top: 8px;
    }

    .detail-form-content .form-footer .el-button {
        min-width: 100px;
        border-radius: 4px;
    }

    .detail-form-content .form-footer .el-button--primary {
        background-color: var(--publicMainColor);
        border-color: var(--publicMainColor);
    }

    .detail-form-content .form-footer .el-button--primary:hover {
        background-color: #2b5797;
        border-color: #2b5797;
    }

    .detail-form-content .form-footer .el-button--default:hover {
        color: var(--publicMainColor);
        border-color: rgba(58, 110, 165, 0.3);
        background-color: rgba(58, 110, 165, 0.06);
    }
</style>